// Waitlist entry helpers shared by the calendar matcher, entry form,
// list page, and convert modal.

// GET /waitlist enriches each provider_ids element from a plain user-id
// string into {_provider: {...}} via the provider addon, while write paths
// and locally-seeded entries use plain string arrays. Normalize to string
// ids regardless of which shape we were handed.
export function normalizeWaitlistProviderIds(providerIds) {
  if (!Array.isArray(providerIds)) return [];
  return providerIds
    .map(p => p?._provider?.id || (typeof p === 'object' && p !== null ? p.id : p))
    .filter(Boolean);
}

export const WAITLIST_PRIORITY_WEIGHT = { high: 3, medium: 2, low: 1 };

// Sort waitlist entries: high priority first, then by created_at.
// Slot candidate lists use 'asc' (longest-waiting first); the list page
// uses 'desc' (newest first).
export function sortWaitlistEntries(entries, createdOrder = 'asc') {
  return [...entries].sort((a, b) => {
    const wa = WAITLIST_PRIORITY_WEIGHT[a.priority] || 0;
    const wb = WAITLIST_PRIORITY_WEIGHT[b.priority] || 0;
    if (wa !== wb) return wb - wa;
    const diff = (a.created_at || 0) - (b.created_at || 0);
    return createdOrder === 'asc' ? diff : -diff;
  });
}
